import { c as _c } from "react/compiler-runtime";
import { PencilSquare } from '@byway/icons';
import { useTranslations } from 'next-intl';
import * as React from 'react';
import useJourneyData from '~/hooks/useJourneyData';
import type { StayTransformed } from '~/types/JourneyItem.types';
import { Link } from '../Link';
import { MessagePanel } from '../MessagePanel';
function JourneyUnavailabilityBanner() {
  const $ = _c(54);
  const t = useTranslations();
  const {
    statusSummary,
    items
  } = useJourneyData();
  const [storedAvailabilityResult, setStoredAvailabilityResult] = React.useState();
  const [shouldShowMessage, setShouldShowMessage] = React.useState(false);
  const [bookingDisabled, setBookingDisabled] = React.useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const referrer = document.referrer;
      const isFromCheckout = referrer.includes("/checkout/") || sessionStorage.getItem("returning_from_checkout") === "true";
      const stored = sessionStorage.getItem("journey_availability_result");
      const disabled = sessionStorage.getItem("booking_disabled") === "true";
      setBookingDisabled(disabled);
      if (stored && !isFromCheckout) {
        setStoredAvailabilityResult(JSON.parse(stored));
        setShouldShowMessage(true);
      } else {
        setShouldShowMessage(false);
      }
      sessionStorage.removeItem("returning_from_checkout");
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  React.useEffect(t0, t1);
  if (bookingDisabled) {
    let t2;
    if ($[2] !== t) {
      t2 = t.rich("content.feedback.availability_unavailable", {
        link: _temp
      });
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <div className="pb-3"><MessagePanel message={t2} status="error" dismissable={true} /></div>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (!shouldShowMessage && !statusSummary?.some(_temp2)) {
    return null;
  }
  if (storedAvailabilityResult) {
    switch (storedAvailabilityResult.result) {
      case "FAIL_TRANSPORT_UNAVAILABLE":
        {
          let t2;
          if ($[6] !== t) {
            t2 = t("content.feedback.availability_transport_booked");
            $[6] = t;
            $[7] = t2;
          } else {
            t2 = $[7];
          }
          let t3;
          if ($[8] !== t2) {
            t3 = <div className="pb-3"><MessagePanel message={t2} status="error" dismissable={true} /></div>;
            $[8] = t2;
            $[9] = t3;
          } else {
            t3 = $[9];
          }
          return t3;
        }
      case "FAIL_ACCOMMODATION_UNAVAILABLE":
        {
          let t2;
          if ($[10] !== t) {
            t2 = t("content.feedback.availability_accommodation_booked");
            $[10] = t;
            $[11] = t2;
          } else {
            t2 = $[11];
          }
          let t3;
          if ($[12] !== t2) {
            t3 = <div className="pb-3"><MessagePanel message={t2} status="error" dismissable={true} /></div>;
            $[12] = t2;
            $[13] = t3;
          } else {
            t3 = $[13];
          }
          return t3;
        }
      case "SUCCESS_WITH_SUBSTITUTIONS":
        {
          if (!storedAvailabilityResult.priceChange?.isPriceHeld) {
            let t2;
            if ($[14] !== t) {
              t2 = t("content.feedback.availability_price_updated");
              $[14] = t;
              $[15] = t2;
            } else {
              t2 = $[15];
            }
            let t3;
            if ($[16] !== t2) {
              t3 = <div className="pb-3"><MessagePanel message={t2} status="info" dismissable={true} /></div>;
              $[16] = t2;
              $[17] = t3;
            } else {
              t3 = $[17];
            }
            return t3;
          }
          let t2;
          if ($[18] !== t) {
            t2 = t("content.feedback.availability_updated");
            $[18] = t;
            $[19] = t2;
          } else {
            t2 = $[19];
          }
          let t3;
          if ($[20] !== t2) {
            t3 = <div className="pb-3"><MessagePanel message={t2} status="info" dismissable={true} /></div>;
            $[20] = t2;
            $[21] = t3;
          } else {
            t3 = $[21];
          }
          return t3;
        }
    }
  }
  if (statusSummary?.some(_temp3)) {
    let t2;
    if ($[22] !== t) {
      t2 = t("content.feedback.availability_transport_unavailable");
      $[22] = t;
      $[23] = t2;
    } else {
      t2 = $[23];
    }
    let t3;
    if ($[24] !== t2) {
      t3 = <div className="pb-3"><MessagePanel message={t2} status="error" dismissable={true} /></div>;
      $[24] = t2;
      $[25] = t3;
    } else {
      t3 = $[25];
    }
    return t3;
  }
  if (statusSummary?.some(_temp4)) {
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[26] !== items || $[27] !== statusSummary || $[28] !== t) {
      const unavailableStayIds = statusSummary.filter(_temp5).map(_temp6);
      const unavailableStays = items.filter(item => unavailableStayIds.includes(item.id)) as StayTransformed[];
      t6 = "pb-3";
      T0 = MessagePanel;
      t5 = true;
      let t7;
      if ($[35] !== t) {
        t7 = t("content.feedback.stay_unavailable");
        $[35] = t;
        $[36] = t7;
      } else {
        t7 = $[36];
      }
      if ($[37] !== t7) {
        t4 = <p>{t7}</p>;
        $[37] = t7;
        $[38] = t4;
      } else {
        t4 = $[38];
      }
      t2 = "mt-2";
      let t8;
      if ($[39] !== t) {
        t8 = stay => <li key={stay.id}><Link href={`#${stay.id}`} isExternal={true} target="_self"><span className="flex items-center gap-1"><PencilSquare decorative={true} />{t("journey.change_accommodation", {
                hotel: stay.title
              })}</span></Link></li>;
        $[39] = t;
        $[40] = t8;
      } else {
        t8 = $[40];
      }
      t3 = unavailableStays.map(t8);
      $[26] = items;
      $[27] = statusSummary;
      $[28] = t;
      $[29] = T0;
      $[30] = t2;
      $[31] = t3;
      $[32] = t4;
      $[33] = t5;
      $[34] = t6;
    } else {
      T0 = $[29];
      t2 = $[30];
      t3 = $[31];
      t4 = $[32];
      t5 = $[33];
      t6 = $[34];
    }
    let t7;
    if ($[41] !== t2 || $[42] !== t3) {
      t7 = <ul className={t2}>{t3}</ul>;
      $[41] = t2;
      $[42] = t3;
      $[43] = t7;
    } else {
      t7 = $[43];
    }
    let t8;
    if ($[44] !== t4 || $[45] !== t7) {
      t8 = <>{t4}{t7}</>;
      $[44] = t4;
      $[45] = t7;
      $[46] = t8;
    } else {
      t8 = $[46];
    }
    let t9;
    if ($[47] !== T0 || $[48] !== t5 || $[49] !== t8) {
      t9 = <T0 dismissable={t5} message={t8} status="error" />;
      $[47] = T0;
      $[48] = t5;
      $[49] = t8;
      $[50] = t9;
    } else {
      t9 = $[50];
    }
    let t10;
    if ($[51] !== t6 || $[52] !== t9) {
      t10 = <div className={t6}>{t9}</div>;
      $[51] = t6;
      $[52] = t9;
      $[53] = t10;
    } else {
      t10 = $[53];
    }
    return t10;
  }
  return null;
}
function _temp6(status_2) {
  return status_2.id;
}
function _temp5(status_1) {
  return status_1.type === "Stay" && status_1.isUnavailable;
}
function _temp4(status_3) {
  return status_3.type === "Stay" && status_3.isUnavailable;
}
function _temp3(status_0) {
  return status_0.type === "Leg" && status_0.isUnavailable;
}
function _temp2(status) {
  return status.type === "Leg" && status.isUnavailable || status.type === "Stay" && status.isUnavailable;
}
function _temp(chunks) {
  return <Link href="https://byway.travel/contact" isExternal={true}>{chunks}</Link>;
}
export { JourneyUnavailabilityBanner };